declare namespace $ {

	export class $shm_hitalama_map_widget_float_code_css extends $shm_hitalama_map_widget_float_code {
		attach( ): any
		Overlay( ): any
		auto( ): readonly(any)[]
		textarea_hint( ): string
	}
	
}

//# sourceMappingURL=css.view.tree.d.ts.map